/**
 * @Description:
 * @Author: jiaxiuc
 * @Date: 2024-03-21
 * @LastEditors: jiaxiuc
 * @LastEditTime: 2024-04-02
 */
import { calendarService } from '@/api/calendar-service';
const useUrlAddUser = async ({ videoUrl, url, isNotVideoUrl } = {}, metting) => {
  const targetUrl = videoUrl || url;
  if (!targetUrl) return;
  if (isNotVideoUrl) {
    // window.open(decodeURIComponent(targetUrl), '_blank');  // 李原野: 去除 decodeURIComponent
    window.open(targetUrl, '_blank');
    return;
  }
  try {
    const params = {
      videoUrl
    };
    let fn = 'addPersonVideoUrl';
    if (metting === 1) {
      fn = 'addMettingVideoUrl';
    }
    if (metting === 2) {
      fn = 'addFollowVideoUrl';
    }
    await calendarService[fn](params);
    window.open(targetUrl, '_blank');
  } catch (e) {
    console.log(e);
    window.open(targetUrl, '_blank');
  }
};
export default useUrlAddUser;
